import { plural } from '@cian/utils';

import { IOffer } from 'shared/types/offers';

interface IOfferSearchType {
  name: string;
  getRightName(): string;
}

const createSearchType = (name: string, getRightName: () => string): IOfferSearchType => {
  return {
    getRightName,
    name,
  };
};

const findTypeById = (values: IOfferSearchType[], offer: IOffer): string => {
  return values.reduce((acc, item) => {
    if (offer.category === item.name + 'Rent' || offer.category === item.name + 'Sale') {
      return item.getRightName();
    }

    return acc;
  }, '');
};

const getType = (offer: IOffer): string => {
  return findTypeById(
    [
      createSearchType('flat', () => {
        if (offer.flatType === 'studio') {
          return 'Студия';
        }
        if (offer.flatType === 'openPlan') {
          return 'Своб. планировка';
        }

        return offer.roomsCount ? `${offer.roomsCount}-комн. кв.` : '';
      }),
      createSearchType('newBuildingFlat', () => {
        if (offer.flatType === 'studio') {
          return 'Студия';
        }
        if (offer.flatType === 'openPlan') {
          return 'Своб. планировка';
        }

        return offer.roomsCount ? `${offer.roomsCount}-комн. кв.` : '';
      }),
      createSearchType('dailyFlat', () => {
        if (offer.flatType === 'studio') {
          return 'Студия';
        }
        if (offer.flatType === 'openPlan') {
          return 'Своб. планировка';
        }

        return offer.roomsCount ? `${offer.roomsCount}-комн. кв.` : '';
      }),
      createSearchType('room', () => {
        return offer.roomsForSaleCount
          ? `${offer.roomsForSaleCount} ${plural(offer.roomsForSaleCount, ['комната', 'комнаты', 'комнат'])}`
          : '1 комната';
      }),
      createSearchType('dailyRoom', () => 'Комната'),
      createSearchType('dailyBed', () => 'Койко-место'),
      createSearchType('dailyHouse', () => 'Дом'),
      createSearchType('bed', () => 'Койко-место'),
      createSearchType('office', () => 'Офис'),
      createSearchType('shoppingArea', () => 'Торговая площадь'),
      createSearchType('warehouse', () => 'Склад'),
      createSearchType('freeAppointmentObject', () => 'Своб. назнач.'),
      createSearchType('business', () => 'Готовый бизнес'),
      createSearchType('building', () => 'Здание'),
      createSearchType('carService', () => 'Автосервис'),
      createSearchType('domesticServices', () => 'Помещение под бытовые услуги'),
      createSearchType('industry', () => 'Помещение под производство'),
      createSearchType('publicCatering', () => 'Общепит'),
      createSearchType('house', () => 'Дом'),
      createSearchType('cottage', () => 'Коттедж'),
      createSearchType('townhouse', () => 'Таунхаус'),
      createSearchType('land', () => 'Участок'),
      createSearchType('commercialLand', () => 'Участок'),
      createSearchType('houseShare', () => {
        return offer.shareAmount ? offer.shareAmount + ' дома' : 'часть дома';
      }),
      createSearchType('flatShare', () => {
        return offer.shareAmount ? offer.shareAmount + ' квартиры' : 'доля';
      }),
      createSearchType('garage', () => {
        if (!offer.garage) {
          return 'Гараж';
        }
        switch (offer.garage.type) {
          case 'box':
            return 'Бокс';
          case 'garage':
            return 'Гараж';
          case 'parkingPlace':
            return 'Машиноместо';
          default:
            return '';
        }
      }),
    ],
    offer,
  );
};

export const getOfferType = (offer: IOffer): string => {
  const type = getType(offer);

  return `${type.charAt(0).toUpperCase()}${type.substring(1)}`;
};
